export default function Footer({ onContactClick }) {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container footer-row">
        <small>© {new Date().getFullYear()} AD Furnished, LLC.</small>
        {/* <button className="contact-btn" onClick={onContactClick} aria-label="Contact us">
          Contact Us
        </button> */}
      </div>
    </footer>
  );
}
